import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { categories } from "../data/landingContent";
import { FadeIn } from "./FadeIn";
const editorialWords = ["HOGAR", "TEXTILES", "COCINA", "AUTO"];
const enterEase = [0.22, 1, 0.36, 1] as const;
export function FormulaCatalog() {
  const reduceMotion = useReducedMotion();
  return <section className="bg-white py-16 sm:py-24 lg:py-28" style={{
    paddingTop: "26px",
    paddingBottom: "33px"
  }} data-id="element-76" data-mp="1j95z30nax7pt">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10" data-id="element-77" data-mp="1n7lr5iy8p6a3">
        <div className="lg:grid lg:grid-cols-[.8fr_1.2fr] lg:gap-20" data-id="element-78" data-mp="1s6yee4t0wfd7">
          <div className="lg:sticky lg:top-10 lg:self-start" data-id="element-79" data-mp="1wyzopl6mrw0l">
            <motion.p className="text-[clamp(3.5rem,14vw,5.5rem)] font-extrabold leading-none tracking-[-0.09em] text-[#0077e8]" initial={reduceMotion ? false : {
            opacity: 0,
            scale: 0.94
          }} whileInView={reduceMotion ? undefined : {
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            amount: 0.35
          }} transition={{
            duration: 0.6,
            ease: enterEase
          }} data-id="element-80" data-mp="1x1lx1n1cifjv">
              +400
            </motion.p>
            <motion.h2 className="mt-1 text-3xl font-extrabold leading-[0.98] tracking-[-0.06em] text-[#091a37] sm:text-4xl" initial={reduceMotion ? false : {
            opacity: 0,
            y: 8
          }} whileInView={reduceMotion ? undefined : {
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.35
          }} transition={{
            duration: 0.42,
            delay: 0.12,
            ease: enterEase
          }} data-id="element-81" data-mp="1bpc8kgpc6c4j">
              FÓRMULAS
              <span className="mt-2 block text-[clamp(1.4rem,6vw,1.65rem)] font-bold leading-[1.05] tracking-[-0.05em]" data-id="element-82" data-mp="1pqeumtgbzmfg">para llevar a la práctica</span>
            </motion.h2>
            <div className="mt-5 max-w-sm text-base leading-7 text-[#526078]" data-id="element-83" data-mp="2iekhpmuuxnig">
              <p data-id="element-84" data-mp="2ichiqdbq8k1l">No vas a encontrar solamente detergente y suavizante.</p>
              <p className="mt-2" data-id="element-85" data-mp="ghk3d7eyvt4a">Explorá fórmulas organizadas según el tipo de producto que quieras elaborar.</p>
            </div>
          </div>

          <div className="mt-8 lg:mt-0" data-id="element-86" data-mp="6r8q2u9e87kq">
            <div className="border-t border-[#d8e4ef] lg:grid lg:grid-cols-2 lg:gap-x-8" data-id="element-87" data-mp="6qfoe7pak89g">
              {categories.map((category, index) => <FadeIn as="div" distance={8} duration={0.4} delay={index * 0.1} className="relative isolate min-h-[124px] overflow-hidden border-b border-[#d8e4ef] py-5 lg:min-h-[150px] lg:py-7" key={category.title} data-id="element-88" data-mp="bnpb3flaq5tl" data-mpi={index}>
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-1 right-0 -z-10 text-5xl font-extrabold leading-none tracking-[-0.1em] text-[#0077e8]/[0.035] lg:text-6xl" data-id="element-89" data-mp="3jxqukeg73xw6">{editorialWords[index]}</span>
                  <div className="grid grid-cols-[62px_1fr] gap-2" data-id="element-90" data-mp="1i5uhh0edqfza">
                    <span className="text-5xl font-extrabold leading-none tracking-[-0.08em] text-[#0077e8]/20" data-id="element-91" data-mp="1n579dzk3yd8q">0{index + 1}</span>
                    <div className="pt-1" data-id="element-92" data-mp="37oazat4kassk">
                      <h3 className="text-lg font-extrabold tracking-[-0.04em] text-[#091a37] sm:text-xl" data-id="element-93" data-mp="37l5c5jfhu0zh">{category.title}</h3>
                      <p className="mt-2 max-w-xs text-sm leading-6 text-[#526078]" data-id="element-94" data-mp="3hcswl0dmuhrg">{category.description}</p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
            <FadeIn distance={8} duration={0.4} delay={0.15} className="mt-8 border-l-2 border-[#0077e8] pl-5 lg:mt-10" data-id="element-95" data-mp="3qdhbdxauom5e">
              <p className="text-[11px] font-extrabold tracking-[0.13em] text-[#526078]" data-id="element-96" data-mp="3lffqd6tv6cra">Y ESTO ES SOLO UNA PARTE</p>
              <p className="mt-2 text-xl font-extrabold leading-[1.15] tracking-[-0.045em] text-[#091a37] sm:text-2xl" data-id="element-97" data-mp="457zn3tv0gxz">Más fórmulas. Más posibilidades para elegir qué fabricar.</p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}